import React, { FC, useState } from 'react';
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Props {
	value: string,
	type?: string,
	isHidden?: boolean,
}
export const PIIComponent: FC<Props> = (props) => {
	const { value, type, isHidden } = props;
	const [isFieldHidden, setIsFieldHidden] = useState<boolean>(isHidden);
	const [isFieldHovered, setIsFieldHovered] = useState<boolean>(isHidden);

	const getMaskedField = (): string => {
		if (!value?.trim()) return;

		switch (type) {
			case 'name': {
				const nameArr = value?.split(' ');
				const maskedName = nameArr?.map(el => {
					const hiddenPart = el?.slice(1, el.length)?.replace(/./g, '*');
					return el[0]?.concat(hiddenPart);
				});
				return maskedName?.join(' ');
			}
			case 'email': {
				const emailArr = value?.split('@');
				const hiddenPart = emailArr[0]?.slice(1,-1)?.replace(/./g, '*');
				const firstEmailPart = emailArr[0][0]?.concat(hiddenPart);
				if (emailArr.length > 1) {
					return `${firstEmailPart}@${emailArr[1]}`;
				} else {
					return firstEmailPart;
				}
			}
			case 'phone': {
				const firstPart = value?.slice(0,2);
				const hiddenPart = value?.slice(2,-1)?.replace(/./g, '*');
				return `${firstPart}${hiddenPart}${value[value.length-1]}`;
			}
			case 'address': {
				const hiddenPart = value?.slice(1,-1)?.replace(/./g, '*');
				return `${value[0]}${hiddenPart}${value[value.length-1]}`;
			}
			default:
				return value?.replace(/./g, '*');
		}
	};

	const getFieldValue = (): JSX.Element => {
		if (!isHidden || !value?.trim()) {
			return (
				<div className="fs-6 ">
					{value?.trim() ? value?.trim() : '-'}
				</div>
			);
		} else {
			return (
				<div className="d-flex align-items-center fs-7">
					<div
						className="fc-text-overflow"
						onMouseEnter={(): void => setIsFieldHovered(false)}
						onMouseLeave={(): void => setIsFieldHovered(true)}
					>
						{isFieldHidden && isFieldHovered ? getMaskedField() : value}
					</div>
					<div
						className="cursor-pointer ms-2"
						onClick={(): void => setIsFieldHidden(!isFieldHidden)}
					>
						<FontAwesomeIcon icon={isFieldHidden ? faEyeSlash : faEye}/>
					</div>
				</div>
			);
		}
	};

	return (
		<>
			{getFieldValue()}
		</>
	);
};